export const environment = {
  production: false,
  apiUrl: 'https://dev.api.portail.my-link.online/api',
};

